module.exports = __webpack_public_path__ + "img/中繼站1_時間到.934ff7b9.png";